import { parse } from 'hub-http/helpers/params';
import { useLocation } from 'react-router-dom';
export function useGetQueryParam(name) {
  const {
    search
  } = useLocation();
  const params = parse(search.slice(1));
  const queryParam = params[name];
  if (!queryParam) {
    return null;
  }
  return decodeURIComponent(queryParam.toString());
}
export function useGetQueryParamWithArrays(name) {
  const {
    search
  } = useLocation();
  const params = parse(search.slice(1));
  const queryParam = params[name];
  if (!queryParam || queryParam === 'undefined') {
    return null;
  }
  if (Array.isArray(queryParam)) {
    return queryParam.map(decodeURIComponent);
  } else {
    const result = queryParam.split(',').map(decodeURIComponent);
    return result.length > 1 ? result : result[0];
  }
}
export const useGetBooleanQueryParam = name => {
  const value = useGetQueryParam(name);
  return value === 'true' ? true : value === 'false' ? false : null;
};